"use strict";

jQuery(document).ready(function ($) {

  $(".jc-filter-ordernation-button").on("click", function () {
    console.log('teste');
    $(".filter-ordernation-container").css("display", "flex");
  });

  $(".jc-sidebar-toggler").on("click", function () {
    $(".jc-sidebar").toggleClass("show");
    $('body').toggleClass("jc-offcanvas-active");
    $(".jc-sidebar").css('z-index', '9999999999999');
  });

  $(".jc-sidebar-close").click(function (e) {
    $(".jc-sidebar").removeClass("show");
    $("body").removeClass("jc-offcanvas-active");
    $(".jc-sidebar").css('z-index', '');
  });

  $('.seemore-section-button').on('click', function () {

    var container = $($(this).attr('data-container'));
    var isExpanded = container.attr('data-is-expanded') === "true";

    if (isExpanded) {
      container.css('max-height', '117px');
      $(this).children('label').text('Ver Mais');
      $(this).children('i').removeClass("jc-icon-chevron-circle-up");
      $(this).children('i').addClass("jc-icon-chevron-circle-down");
    } else {
      container.css('max-height', 'unset');
      $(this).children('label').text('Ver Menos');
      $(this).children('i').removeClass("jc-icon-chevron-circle-down");
      $(this).children('i').addClass("jc-icon-chevron-circle-up");
    }

    container.attr('data-is-expanded', !isExpanded);
  });

  $('#jc-filter-ordernation-button').on('click', function () {
    $('.filter-ordernation-container').css('display', 'flex');
    $('body').css('overflow', 'hidden');
  });

  $('.filter-ordernation-container').on('click', function () {
    $(this).css('display', 'none');
    $('body').css('overflow', 'auto');
  });

  $('#filter-ordernation-bottom-sheet-options div').on('click', function () {

    var currentValue = $(this).attr('data-value');

    $('#filter-ordernation-bottom-sheet-options div').each(function () {

      if ($(this).attr('data-value') !== currentValue) {
        $(this).attr('data-is-selected', false);
        $(this).children('i').addClass('d-none');
        $(this).removeClass('font-weight-bold');
      }
    });

    $(this).attr('data-is-selected', true);
    $(this).children('i').removeClass('d-none');
    $(this).addClass('font-weight-bold');

    filter_offers();
  });

  $('.filter-section-card').on('click', function (e) {

    e.preventDefault();
    e.stopPropagation();

    var isSelected = $(this).attr('data-is-selected') === "true";

    if (isSelected) {
      $(this).removeClass("filter-selected-card");
      $(this).addClass("filter-unselected-card");
    } else {
      $(this).removeClass("filter-unselected-card");
      $(this).addClass("filter-selected-card");
    }

    $(this).attr('data-is-selected', !isSelected);
    filter_offers();
  });

  $('#ordination-select').on('change', function () {
    filter_offers();
  });

  $('#filter-fab-button').click(function () {
    $("html, body").animate({ scrollTop: 0 }, 700);
    return false;
  });

  var lastScrollTop = 0;
  $(window).scroll(function (event) {

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        $('#header').hide();
        $('#crumbs').hide();
        $('#filter-fab-container').fadeIn(function () {
          $(this).css('display', 'flex');
        });

        $('#filter-buttons-container').removeClass('d-flex');
        $('#filter-buttons-container').addClass('d-none');

        $('body').find('iframe').each(function () {

          var attr = $(this).attr('title');

          if (typeof attr !== 'undefined' && attr !== false) {
            $(this).css('display', 'none');
          }
        });
      } else {

        if ($(window).scrollTop() === 0) {

          $('#header').show();
          $('#crumbs').show();
          $('#filter-fab-container').fadeOut();

          $('body').find('iframe').each(function () {

            var attr = $(this).attr('title');

            if (typeof attr !== 'undefined' && attr !== false) {
              $(this).css('display', '');
            }
          });

          $('#filter-buttons-container').addClass('pt-3');
          $('#filter-buttons-container').addClass('pb-3');

          $('#filter-buttons-container').removeClass('filter-fixed-top-buttons');
        } else {

          $('#filter-buttons-container').removeClass('d-none');
          $('#filter-buttons-container').addClass('d-flex');

          $('#filter-buttons-container').removeClass('pt-3');
          $('#filter-buttons-container').removeClass('pb-3');

          $('#filter-buttons-container').addClass('filter-fixed-top-buttons');
        }
      }
      lastScrollTop = st;
    }
  });

  var $catalog_conteudo = $('#catalog-list'),
      $filterInputs = $('.jc-vertical-filter input'),
      $marcas = $('#brands-container'),
      $estilosDeVida = $('#lifestyle-container'),
      $carrocerias = $('#bodywork-container'),
      $min_price = $('input[name="min_price"]'),
      $max_price = $('input[name="max_price"]'),
      $filtro_modelos = $('.filtro_modelos'),
      $limpar_filtro_btn = $('.jc-btn-limpar-filtro'),
      category = $catalog_conteudo.data('category'),
      page = 1,
      filter_mobile_bar = $('.jc-filter-mobile-bar'),
      offers_loader = $('.jc-offers-loading'),
      loader = $('.jc-loader'),
      filterParams = [],
      bodyworksList = $('#bodyworks-list'),
      lifestylesList = $('#lifestyles-list'),
      pages,
      no_result;

  $('body>footer').remove();

  update_pages();
  update_no_result();

  loader.addClass('d-none');

  // Filtra ofertas
  function filter_offers() {
    page = 1;

    var filters = {
      marcas: get_selected_options($marcas),
      carrocerias: get_selected_options($carrocerias),
      estilosDeVida: get_selected_options($estilosDeVida),
      min_price: $min_price.val().length > 0 ? convert_price($min_price.val()) : null,
      max_price: $max_price.val().length > 0 ? convert_price($max_price.val()) : null,
      ordination: get_ordination()
    };

    var base_url = $catalog_conteudo.data('base-url');
    update_url(filters, base_url);
    filters.action = 'jc_ajax_get_catalog';

    filters.page = page;
    filters.category = category;

    setFilteredCheckedNumber();

    $catalog_conteudo.empty();
    loader.removeClass('d-none');
    $('.filter-ordernation-container').css('display', 'none');
    $('#filter-buttons-container').removeClass('d-flex');
    $('#filter-buttons-container').addClass('d-none');

    // Faz requisição e altera resultados exibidos
    $.ajax({
      url: ofertasAjaxHandler.url,
      type: 'GET',
      data: filters,
      success: function success(response) {
        console.log(response);
        $catalog_conteudo.html(response.data.template);
        update_pages();
        update_no_result();
        gtm_count_offers_impression();
        loader.addClass('d-none');
        $('#filter-buttons-container').addClass('d-flex');
        $('#filter-buttons-container').removeClass('d-none');
      },
      error: function error(data) {
        console.log(data);
      }
    });
  }

  function get_catalog_scroll() {

    var filters = {
      action: 'jc_ajax_get_catalog',
      marcas: get_selected_options($marcas),
      carrocerias: get_selected_options($carrocerias),
      estilosDeVida: get_selected_options($estilosDeVida),
      min_price: $min_price.val().length > 0 ? convert_price($min_price.val()) : null,
      max_price: $max_price.val().length > 0 ? convert_price($max_price.val()) : null,
      ordernation: get_ordination(),
      category: category,
      page: page
    };

    // Faz requisição e altera resultados exibidos
    $.ajax({
      url: ofertasAjaxHandler.url,
      type: 'GET',
      data: filters,
      success: function success(response) {
        $catalog_conteudo.append(response.data.template);
        // dataLayer.push({
        //   'event': 'VirtualPageview',
        //   'virtualPageURL': window.location.pathname + window.location.search,
        //   'virtualPageTitle': 'Catálogo - Filtro'
        // });

        // dataLayerEstadao.push({
        //   'event': 'forcePvCheckout',
        //   'page': window.location.pathname + window.location.search
        // });

        // gtag('event', 'VirtualPageview', {
        //   'virtualPageURL': window.location.pathname + window.location.search,
        //   'virtualPageTitle': 'Catálogo - Filtro'
        // });

        // gtag('event', 'forcePvCheckout', {
        //   'page': window.location.pathname + window.location.search
        // });

        update_no_result();

        gtm_count_offers_impression();
        loader.addClass('d-none');
      },
      error: function error(data) {
        console.log(data);
      }
    });
  }

  function unselected_all_cards() {
    $('.filter-section-card').each(function () {

      if ($(this).hasClass('filter-selected-card')) {
        $(this).removeClass('filter-selected-card');
        $(this).addClass('filter-unselected-card');
        $(this).attr('data-is-selected', 'false');
      }
    });
  }

  // Volta filtro para estado default
  function reset_filters(update) {
    no_result = false;
    pages = false;
    $(document).scrollTop(0);
    page = 1;
    unselected_all_cards();
    $(".jc-vertical-filter input:text").val(null);

    if ($('#ordination-select').is(':visible')) {
      $('#ordination-select').find('option:eq(0)').prop('selected', true);
    } else {}

    // Atualiza url
    if (update) {
      update_url({}, $catalog_conteudo.data('base-url'));
    }
  }

  getFilterParameters();
  setFilteredElements();
  setFilteredCheckedNumber();

  var midiaOrigin = '';
  midiaOrigin += typeof filterParams['utm_campaign'] !== "undefined" ? 'utm_campaign=' + filterParams['utm_campaign'][0] : '';
  midiaOrigin += typeof filterParams['utm_medium'] !== "undefined" ? '&utm_medium=' + filterParams['utm_medium'][0] : '';
  midiaOrigin += typeof filterParams['utm_source'] !== "undefined" ? '&utm_source=' + filterParams['utm_source'][0] : '';
  midiaOrigin += typeof filterParams['utm_content'] !== "undefined" ? '&utm_content=' + filterParams['utm_content'][0] : '';
  midiaOrigin += typeof filterParams['utm_term'] !== "undefined" ? '&utm_term=' + filterParams['utm_term'][0] : '';
  midiaOrigin = midiaOrigin != '' ? '?' + (midiaOrigin.indexOf('&') != 0 ? midiaOrigin : midiaOrigin.substring(1)) : '';
  console.log(midiaOrigin);

  $(document).on("click", ".jc-card a", function () {
    $(this).attr('href', $(this).attr("href") + midiaOrigin);
  });

  // Preço mínimo - digitação
  $min_price.bind('keypress', function (e) {
    $(this).mask("#.##0", { reverse: true });
  });

  //Preço máximo - digitação
  $max_price.bind('keypress', function (e) {
    $(this).mask("#.##0", { reverse: true });
  });

  // Preco mínimo
  $min_price.change(function () {
    check_prices();
    filter_offers();
  });

  // Preco máximo
  $max_price.change(function () {
    check_prices();
    filter_offers();
  });

  // Limpar filtro
  $limpar_filtro_btn.click(function (e) {
    reset_filters(true);
    filter_offers();
  });

  //Compartamento filtro mobile

  $('.jc-filter-mobile-show').click(function (event) {
    $('.jc-filter-bar').toggleClass('show');
    $('body').toggleClass('modal-open');
  });

  //Desabilita comportamento menu principal do Jornal do Carro

  $('.jc-nav-wrapper').css('position', 'static');
  $('.jc-nav-top-bar').remove();

  //Visibilidade da barra de filtro

  var filterMobileBar = $('.jc-mobile-offer-filter-bar');
  var footer = $('#offers-footer');

  $(window).scroll(function () {
    var filterAreaLimit = footer.offset().top - (footer.height() + 150);
    if ($(this).scrollTop() > filterAreaLimit && !filterMobileBar.hasClass('hide')) {
      filterMobileBar.fadeOut();
      filterMobileBar.addClass('hide');
    } else if ($(this).scrollTop() < filterAreaLimit && filterMobileBar.hasClass('hide')) {
      filterMobileBar.fadeIn();
      filterMobileBar.removeClass('hide');
    }
  });

  //Comportamento dropdown no filtro

  $('.jc-filter-content .dropdown-menu').on('click', function (event) {
    event.stopPropagation();
  });

  function getFilterParameters() {
    var pathname = decodeURIComponent(window.location.search.substring(1).replace(/\+/g, '%20'));

    if (pathname) {
      var variables = pathname.split('&');

      filterParams = [];

      for (var i = 0; i < variables.length; i++) {
        var elements = variables[i].split(/,|=/);
        var name = elements[0];
        var params = [];

        for (var j = 1; j < elements.length; j++) {
          params.push(elements[j]);
        }

        if (params[0]) {
          filterParams[name] = params;
        }
      }
    } else {
      filterParams = [];
    }
  }

  //Marca as opções de filtro de acordo com a url
  function setFilteredElements() {

    $filterInputs.each(function () {
      setInputValue(this);
    });
  }

  function setInputValue(el) {
    var inputName = $(el).attr('name').replace("[]", "");
    var inputType = $(el).attr('type');
    var inputValue = $(el).val();
    var params = filterParams[inputName];

    //Checa se o valor existe nos parâmetros do filtro
    if (typeof params != 'undefined') {
      for (var i = 0; i < params.length; i++) {
        if (inputType == 'checkbox') {
          if (filterParams[inputName][i] === inputValue) {
            $(el).prop("checked", true);
            break;
          }
        } else {
          $(el).val(params);
        }
      }
    }
  }

  //Marca o número de opções do tipo checkbox marcadas
  function setFilteredCheckedNumber() {

    var totalFilters = 0;

    $('.jc-filter-check-count').each(function (index, el) {
      var checkGroup = el.closest('.jc-filter-check-group');
      var checkInputs = $(checkGroup).find('input:checkbox:checked');
      var textInputs = $(checkGroup).find('input:text').filter(function () {
        return $(this).val();
      });
      var elementFilters = checkInputs.length + textInputs.length;

      // Inputs
      if (elementFilters > 0) {
        $(this).html(elementFilters).addClass('jc-filter-check-counted');
      } else {
        $(this).removeClass('jc-filter-check-counted');
      }

      totalFilters = totalFilters + elementFilters;
    });

    if (totalFilters > 0) {
      $('.jc-btn-offer-filter').addClass('jc-btn-offer-filtered');
      $('.jc-filter-total-count').html(totalFilters);
    } else {
      $('.jc-btn-offer-filter').removeClass('jc-btn-offer-filtered');
      $('.jc-filter-total-count').empty();
    }
  }

  function check_prices() {
    var max_price = $max_price.val();
    var min_price = $min_price.val();

    if (min_price.length > 0 && max_price.length > 0) {
      max_price = convert_price(max_price);
      min_price = convert_price(min_price);

      if (min_price > max_price) {
        $max_price.val(min_price);
        $min_price.val(max_price);
      }
    }
  }

  // Função que busca opções selecionadas dado o tipo de filtro
  function get_selected_options(container) {

    var selected_options = [];

    container.find('.filter-section-card').each(function () {

      var isSelected = $(this).attr('data-is-selected') === "true";

      if (isSelected) {
        selected_options.push($(this).children('input').val());
      }
    });

    return selected_options.join(',');
  }

  function get_ordination() {

    var selected_ordenation = "recent";

    if ($('#ordination-select').is(':visible')) {
      selected_ordenation = $('#ordination-select').val();
    } else {
      $('#filter-ordernation-bottom-sheet-options div').each(function () {

        if ($(this).attr('data-is-selected') === "true") {
          selected_ordenation = $(this).attr('data-value');
        }
      });
    }

    return selected_ordenation;
  }

  // Atualiza URL dados os parâmetros do filtro
  function update_url(filters, base_url) {
    $.each(filters, function (index, value) {
      if (value === "" || value === null || value === []) {
        delete filters[index];
      }
    });

    var url_query = $.param(filters, true);
    if (url_query) {
      base_url += '?' + url_query;
    }

    window.history.pushState("", "", base_url);
  }

  // Converte de "dinheiro" para inteiro
  function convert_price(price_text) {
    return parseInt(price_text.replace(/\./g, ''));
  }

  function update_pages() {
    pages = parseInt($catalog_conteudo.find('[data-pages]').data('pages'));
  }

  function update_no_result() {
    no_result = $('.jc-offers-no-result').length > 0;
  }

  $('.jc-sidebar-content').on('scroll', load_more_content);
  $('.jc-sidebar-content').on('touchmove', load_more_content);

  function load_more_content() {
    if (loader[0].classList.contains('d-none') && !no_result && pages > page && is_bottom_visible()) {
      page++;
      loader.removeClass('d-none');
      get_catalog_scroll();
    }
  }

  function is_bottom_visible() {
    var scroll = $('.jc-sidebar-content')[0].scrollTop;
    var maxScrollHeight = $('.jc-sidebar-content')[0].scrollHeight - $('.jc-sidebar-content')[0].clientHeight;
    var footerHeight = $('#footer')[0].clientHeight;
    return maxScrollHeight - scroll - footerHeight <= 30;
  }
});